import app from '@/../package.json';

export const appVersion = app.version;
